import React from 'react';
import PropTypes from 'prop-types';
import { PageSection, SectionBody, SectionHeader } from './PageSection';
import ResourceCard from './ResourceCard';
import styled from 'styled-components';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Heading, Box, Text } from 'grommet';
import Link from './Link';
import RichText from './RichText';
import { navigate } from 'gatsby-link';

const StyledProductCard = styled.div`
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto 1fr;
  max-width: 400px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);

  > div:nth-of-type(2) {
    display: flex;
    height: 100%;
    flex-direction: column;
    padding: 20px;
  }
`;

const ProductCard = ({ title, image, ctaUrl, ctaLabel, body }) => {
  const handleClick = () => {
    navigate(ctaUrl);
  };

  return (
    <StyledProductCard>
      <div>
        <GatsbyImage image={image.gatsbyImageData} />
      </div>
      <div>
        <Box flex="grow" pad={{ bottom: '20px' }} onClick={() => handleClick()}>
          <Heading level="5">{title}</Heading>
        </Box>
        <Box flex="grow" pad={{ bottom: '20px' }} onClick={() => handleClick()}>
          <RichText richText={body} />
        </Box>
        <Box>
          <Text>
            <Link href={ctaUrl}>{ctaLabel}</Link>
          </Text>
        </Box>
      </div>
    </StyledProductCard>
  );
};

const CardsGrid = styled.div`
  display: grid;
  grid-gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minMax(380px, 1fr));
  grid-auto-rows: auto;
  justify-content: center;

  @media ${({ theme }) => theme.custom.layouts.below_medium} {
    grid-template-columns: auto;
  }
  @media ${({ theme }) => theme.custom.layouts.above_medium} {
    grid-template-columns: repeat(6, 1fr);

    > div {
      grid-column: span 2;

      &:last-child:nth-child(3n - 1) {
        grid-column-end: -2;
      }

      &:nth-last-child(2):nth-child(3n + 1) {
        grid-column-end: 4;
      }
      /* Dealing with single orphan */

      &:last-child:nth-child(3n - 2) {
        grid-column-end: 5;
      }
    }
  }
`;

const ProductCardsSection = ({ title, subtitle, items }) => {
  return (
    <PageSection>
      <SectionHeader title={title} subtitle={subtitle} />
      <SectionBody>
        <CardsGrid>
          {items.map((item, index) => {
            return <ProductCard {...item} key={`${index}-${item.title}`} />;
          })}
        </CardsGrid>
      </SectionBody>
    </PageSection>
  );
};

ProductCardsSection.propTypes = {};

export default ProductCardsSection;
